




















































import axios from "axios";
import Fact, { FactRecordHolder, getFactByID } from "@/models/Fact";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class DocumentFactsTable extends Vue {
  @Prop({ type: Number }) id!: number;

  private facts: FactRecordHolder[] = [];
  private loading: boolean = false;
  private error: boolean = false;

  private headers: object[] = [
    { text: "Name", value: "name" },
    { text: "Figure", value: "figure" },
    { text: "Country", value: "country" },
    { text: "Type", value: "type" },
    { text: "Cause", value: "displacement_type" },
    { text: "Actions", value: "name", sortable: false },
  ];

  async created() {
    if (!!this.id) {
      await this.loadFacts();
    }
  }

  async loadFacts() {
    this.loading = true;
    try {
      let response = await axios.get("/psql/facts_view", {
        params: { document_id: `eq.${this.id}` },
      });

      this.facts = response.data.map((record: any) => ({
        id: record.id,
        parkingLot: false,
        data: record,
      }));
    } catch (error) {
      console.error(error.response);
      this.error = true;
    }
    this.loading = false;
  }

  async loadFact(id: number) {
    this.$emit("loadingFact", true);
    try {
      let response = await getFactByID(id);
      this.$emit("factLoaded", {
        id,
        parkingLot: false,
        data: response.data,
      });
      this.$toast.success("Fact is loaded");
    } catch (error) {
      console.error(error);
      console.error(error.response);
      this.$toast.error("Failed to load fact");
    }
    this.$emit("loadingFact", false);
  }

  newFact() {
    if (!!this.id) {
      let fact = new Fact();
      delete fact.id;
      fact.document_id = this.id;
      this.$emit("factLoaded", {
        id: null,
        parkingLot: false,
        data: fact,
      });
      this.$toast.success("New fact added but not saved yet!");
    } else {
      this.$toast.error("Failed to add new fact, save the document first.");
    }
  }
}
